const NBSP = " ";

// When a title ends in a short trailing word of 1 or 2 characters
// ("CHAOS CREW 3", "SUPER 99"), swap the preceding space for a non-breaking
// space so the browser cannot wrap that short word onto its own line.
const preventTrailingShortOrphan = (title: string) =>
  title.replace(/ (\w{1,2})$/, `${NBSP}$1`);

export const getGameTitle = (name: string) => ({
  title: preventTrailingShortOrphan(name.trim()),
});
